
export class Product {
  Id: string;
  Title: string;
  GrossPremium: string;
  CoveragePeriod: string;
  CoverageStartOffset: string;
  SalesPrice: string;
  ProductLiabilityLimit: string;
  IsPreferredPlan: boolean;
  ClaimLimitPerYear: string;
  DefaultBillingFrequencyCode:string;
  PricingList: PricingStructure[];
  ProductFeatures: ProductFeature[];
  RetailPriceDiscrepancy:boolean;
  ProductCategory: string;
}

export class GadgetResponse {
  AllowMobiles: boolean;
  AllowGadgets: boolean;
  gadgets: Product[];
}
export class SelectedProduct {
  Id: string;
  Title: string;
  Cost: string;
  Frequency: string;
  FrequencyInMonths: number;
  GrossPremium: string;
  CertificateDuration: string;
  CoverageStartOffset: string;
  SalesPrice: string;
  IsPreferredPlan: boolean;
  PreferredPlanName: string;
  TotalCost?: string;
  TotalGrossPremium?: string;
  ClaimLimitPerYear:string;
  ProductLiabilityLimit: string;
  DeductibleTheft:string;
  DeductibleDamage:string;
  CoveragePeriod:number;
  ProductFeatures: ProductFeature[];
  ProductCategory: string;
}

export class PricingStructure {
  Description: string;
  FeatureType: string;
  Id: string;
  MaxCoverageAmount: string;
  Title: string;
  Value: string;
  Months: number;
  ContractTerm: string;
}

export class ProductFeature {
  Id: string;
  Title: string;
  Value: string;
  DeductibleTheft:string;
  DeductibleDamage:string;
  ExtendedCover:string;
  DurationInMonths:number;
}



export class ProductType {
  Id: string;
  Key: string;
  Value: string;
  counter: string;
}

export class ProductBrand {
  Id: string;
  Key: string;
  Value: string;
  TypeId:string;
  counter: string;
}

export class ProductModel {
  Id: string;
  Key: string;
  Value: string;
  TypeId:string;
  BrandId:string;
  counter: string;
}

export class PriceRanges {
  Id: string;
  Key: string;
  Value: string;
}



export class GoogleAnalyticProduct {
  constructor(
    name: string,
    id: string,
    price: string,
    quantity: number) { }
}


export class GoogleAnalyticSelectedDevice {
  imei: string | '';
  make: string | '';
  model: string | '';
  value: string | '';
  constructor(
    imei: string,
    make: string,
    model: string,
    value: string) {
    this.imei = imei;
    this.make = make;
    this.model = model;
    this.value = value;
  }
}


export class AthenaRequest {
  athenaDeviceProducts: AthenaDeviceProduct[];
  discountCode?: string;
}

export class AthenaDeviceProduct {
  imeiNumber: string;
  item: string
  itemNumber: string;
  loss: string;
  make: string;
  model: string;
  value: string;
}

export class AthenaInfo {
  GadgetPremiumValueCollection: GadgetPremiumValue[];
  ErrorResponse: boolean;

  constructor() {
    this.GadgetPremiumValueCollection = [];
    this.ErrorResponse = false;
 }
}

export class GadgetPremiumValue {
  GadgetCoverTypeField: Number;
  ItemPremiumValue: GadgetItemDetails[]
  MarketingCodeCheck: string;
  MarketingDiscountDetails: MarketingDiscountDetails;
  MultiItemDiscountDetails: MultiItemDiscountDetails;
  TotalValueA: string;
  TotalValueM: string;
}

export class MultiItemDiscountDetails {
  DiscountAmountAnnual: Number;
  DiscountAmountMonthly: Number;
  DiscountCode: string;
  DiscountPct: Number;
}

export class MarketingDiscountDetails {
  DiscountAmountAnnual: Number;
  DiscountAmountMonthly: Number;
  DiscountCode: string;
  DiscountPct: Number;
}

export class GadgetItemDetails {
  AccDamExcessAmount: Number;
  ItemLoss: boolean;
  ItemLossValueA: Number;
  ItemLossValueM: Number;
  ItemNumber: Number;
  ItemPremiumValue: Number;
  LossApplied: Number;
  LossExcessAmount: Number;
  TheftExcessAmount: Number;
  ProductCode: string;
}

